<div class="cmsPage">
      <app-cms-top-bg></app-cms-top-bg>
      <!-- Dynamic content -->
      <div class="PageContent">
            <div [innerHTML]="safeHtmlContent"></div>
      </div><!-- Dynamic content ends -->
      <app-cms-bottom></app-cms-bottom>
</div>